import { useScrollAnimation } from '@/hooks/useScrollAnimation';

/**
 * Komponen wrapper untuk scroll-triggered animations
 * Berbagai jenis animasi: fade, slide, scale, dll
 */
export default function ScrollReveal({ 
  children, 
  animation = 'fade-up',
  delay = 0,
  duration = 0.6,
  threshold = 0.1,
  triggerOnce = true,
  className = ''
}) {
  const [ref, isVisible] = useScrollAnimation({ threshold, triggerOnce });

  const animationStyles = {
    'fade': {
      initial: { opacity: 0 },
      animate: { opacity: 1 }
    },
    'fade-up': {
      initial: { opacity: 0, transform: 'translateY(30px)' },
      animate: { opacity: 1, transform: 'translateY(0)' }
    },
    'fade-down': {
      initial: { opacity: 0, transform: 'translateY(-30px)' },
      animate: { opacity: 1, transform: 'translateY(0)' }
    },
    'fade-left': {
      initial: { opacity: 0, transform: 'translateX(30px)' },
      animate: { opacity: 1, transform: 'translateX(0)' }
    },
    'fade-right': {
      initial: { opacity: 0, transform: 'translateX(-30px)' },
      animate: { opacity: 1, transform: 'translateX(0)' }
    },
    'scale': {
      initial: { opacity: 0, transform: 'scale(0.9)' },
      animate: { opacity: 1, transform: 'scale(1)' }
    },
    'scale-up': {
      initial: { opacity: 0, transform: 'scale(0.8)' },
      animate: { opacity: 1, transform: 'scale(1)' }
    },
    'flip': {
      initial: { opacity: 0, transform: 'rotateX(-30deg)' },
      animate: { opacity: 1, transform: 'rotateX(0)' }
    }
  };

  const style = animationStyles[animation] || animationStyles['fade-up'];
  
  return (
    <div
      ref={ref}
      className={className}
      style={{
        ...(isVisible ? style.animate : style.initial),
        transition: `all ${duration}s cubic-bezier(0.4, 0, 0.2, 1) ${delay}s`,
        willChange: 'opacity, transform'
      }}
    >
      {children}
    </div>
  );
}

/**
 * Komponen untuk stagger animation (animasi berurutan)
 * Berguna untuk list items
 */
export function StaggerGroup({ 
  children, 
  staggerDelay = 0.1,
  animation = 'fade-up',
  threshold = 0.1,
  className = ''
}) {
  const [ref, isVisible] = useScrollAnimation({ threshold, triggerOnce: true });

  return (
    <div ref={ref} className={className}>
      {Array.isArray(children) 
        ? children.map((child, index) => (
            <ScrollReveal
              key={index}
              animation={animation}
              delay={index * staggerDelay}
              threshold={0}
              triggerOnce={true}
            >
              {child}
            </ScrollReveal>
          ))
        : children
      }
    </div>
  );
}
